import { dataServiceBaseUrl } from "@coworker/app/src/core/cloud-services/cloud-services.helper";
import { isChineseEnvironment } from "@coworker/reusable/helpers/devices";
import { getEnvironmentId } from "@coworker/reusable/helpers/environment";
import { makeServiceHeaders } from "../../core/hooks/fetch.helpers";

const isChina = isChineseEnvironment();

export const DATA_SERVICE_URL = dataServiceBaseUrl(getEnvironmentId(), isChina);

export async function fetchAPI(path: string, method: string, body: unknown) {
  const url = `${DATA_SERVICE_URL}/${path}`;

  const options: { method: string; headers: HeadersInit; body?: string } = {
    method,
    headers: await makeServiceHeaders(),
  };

  if (method !== "GET") {
    options.body = JSON.stringify(body);
  }

  const response = await fetch(url, options);

  if (!response.ok) {
    throw new Error("Response was not ok.");
  }

  const text = await response.text();
  return JSON.parse(text);
}
